import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './BestMobilityAids.css';

const BestMobilityAids = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.primerehabindustries.in/#organization",
          "name": "Prime Rehab Industries",
          "url": "https://www.primerehabindustries.in",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://primerehabindustries.in/Image/Logo.png"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.primerehabindustries.in/#localbusiness",
          "name": "Prime Rehab Industries",
          "parentOrganization": { "@id": "https://www.primerehabindustries.in/#organization" },
          "description": "Prime Rehab Industries manufactures and supplies the best mobility aids and rehabilitation products in Tamil Nadu, including tilting tables, unweighing systems, traction tables, and a full range of physiotherapy equipment for clinics and hospitals.",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          },
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "url": "https://www.primerehabindustries.in",
          "sameAs": [
            "https://maps.app.goo.gl/placeholder"
          ],
          "areaServed": ["Tamil Nadu", "India"],
          "openingHours": "Mo-Sa 09:00-18:00"
        },
        {
          "@type": "Product",
          "name": "High Low Tilting Table",
          "description": "Motorized hi-low and tilting rehabilitation table with harness and lockable clips, foot leg adjustment board from +20 to -120 degrees, writing board support, and moving wheels with brake. Height range 59 to 93 cm. Designed for postural and weight-bearing mobility rehabilitation.",
          "brand": { "@id": "https://www.primerehabindustries.in/#organization" },
          "manufacturer": { "@id": "https://www.primerehabindustries.in/#organization" },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "92",
            "bestRating": "5",
            "worstRating": "1"
          },
          "review": [
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Dr. Anand Krishnamurthy" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "reviewBody": "The tilting table from Prime Rehab has been a game changer for our mobility rehabilitation program. The motorized tilt is smooth and the harness system gives patients real confidence during standing therapy.",
              "datePublished": "2025-03-18"
            },
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Dr. Suganya Vijay" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "reviewBody": "We sourced our mobility rehabilitation equipment entirely from Prime Rehab. The quality across every product is consistent and the team was very professional throughout. Excellent company to work with.",
              "datePublished": "2025-10-05"
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What mobility aids and rehab products does Prime Rehab Industries supply in Tamil Nadu?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Prime Rehab Industries supplies a comprehensive range of mobility aids and rehab products in Tamil Nadu including high low tilting tables, unweighing systems for gait training, traction tables, Bobath neuro therapy tables, chiropractic tables, and multi-section treatment tables. All products are manufactured in-house and cover physiotherapy, orthopaedic, neurological, and mobility rehabilitation needs."
              }
            },
            {
              "@type": "Question",
              "name": "Are Prime Rehab Industries products suitable for post-surgery mobility rehabilitation?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries manufactures products specifically suited for post-surgery mobility rehabilitation, including the High Low Tilting Table for progressive weight-bearing, the Unweighing System for supported gait training, and height-adjustable treatment tables for active mobility exercises. These are trusted by 500+ clinics and hospitals across India."
              }
            },
            {
              "@type": "Question",
              "name": "Can Prime Rehab Industries supply both mobility aids and full rehabilitation equipment setups?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries offers over 100 rehabilitation equipment models, allowing clinics and hospitals to source their full equipment setup from a single manufacturer. From individual mobility aids like tilting tables and unweighing systems to complete physiotherapy department configurations, the company supplies everything needed."
              }
            },
            {
              "@type": "Question",
              "name": "How does Prime Rehab Industries ensure the quality of its mobility and rehab products?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Prime Rehab Industries manufactures all its mobility and rehab products in-house, maintaining direct control over frame quality, mechanism engineering, and upholstery selection. With 12+ years of manufacturing experience and 1,000+ successful installations, every product is built to withstand the demands of continuous clinical use."
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.primerehabindustries.in"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Blog",
              "item": "https://www.primerehabindustries.in/blog"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Best Mobility Aids and Rehab Products in Tamil Nadu",
              "item": "https://www.primerehabindustries.in/blog/best-mobility-aids-rehab-products-tamil-nadu"
            }
          ]
        }
      ]
    };

    document.title = "Mobility Aids and Rehab Products Tamil Nadu | Prime Rehab";

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Prime Rehab Industries offers the best mobility aids and rehab products in Tamil Nadu, with 100+ models and 12+ years of manufacturing expertise.";

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = "https://www.primerehabindustries.in/blog/best-mobility-aids-rehab-products-tamil-nadu";

    let script = document.querySelector('#blog-schema');
    if (!script) {
      script = document.createElement('script');
      script.id = 'blog-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.innerHTML = JSON.stringify(schema);

    return () => {};
  }, []);

  return (
    <div className="soft-layout-page">
      <Navbar />

      {/* Floating Blobs Background for entire page vibe */}
      <div className="soft-blob blob-1"></div>
      <div className="soft-blob blob-2"></div>

      {/* Glassmorphism Hero Section */}
      <section className="soft-hero">
        <div className="soft-container">
          <div className="glass-card hero-glass">
            <div className="hero-text-content">
              <span className="soft-badge">Rehabilitation Equipment Guide</span>
              <h1>Best Mobility Aids and Rehab Products in Tamil Nadu</h1>
              <p>
                Regaining mobility after a serious illness, injury, or surgery is rarely a straight line. There are setbacks, plateaus, and moments where the right equipment makes the difference between a patient taking their next step confidently and spending another week in bed.
              </p>
              <div className="hero-actions">
                <a href="/products" className="soft-btn-primary">View Equipment</a>
                <a href="/contact" className="soft-btn-secondary">Request Quote</a>
              </div>
            </div>
            <div className="hero-image-content">
              <img src="https://primerehabindustries.in/Image/Product/Pro4.png" alt="Prime Rehab Industries High Low Tilting Table — best mobility aids and rehab products in Tamil Nadu" />
            </div>
          </div>
        </div>
      </section>

      {/* Clean Intro Box */}
      <section className="soft-intro">
        <div className="soft-container">
          <div className="clean-intro-box">
            <h2 className="soft-gradient-text">What Are Mobility Aids and Rehab Products Used For?</h2>
            <p>
              Mobility aids in a clinical rehabilitation context are not the same as everyday walking aids. They are specialised pieces of equipment that help therapists guide patients through structured recovery from the earliest stages of assisted standing to complex gait retraining and full weight bearing rehabilitation.
            </p>
            <p>
              These products support patients recovering from strokes, spinal cord injuries, major joint replacements, fractures, and neurological conditions. They give therapists the control to progress treatment safely, and they give patients the support to build confidence in their own movement step by step.
            </p>
          </div>
        </div>
      </section>

      {/* Soft Floating Cards for Features */}
      <section className="soft-features">
        <div className="soft-container">
          <div className="section-title-soft">
            <h2>Prime Rehab Industries</h2>
            <p>A Complete Source for Mobility and Rehab Products in Tamil Nadu</p>
          </div>

          <div className="floating-cards-grid">
            <div className="floating-card">
              <div className="card-icon-wrapper">1</div>
              <h4>Equipment Engineered for Real Mobility Challenges</h4>
              <p>Every Prime Rehab product is built around how rehabilitation actually works in a clinical setting. The frames are engineered to handle real patient loads over years of daily use. The mechanisms motorized tilts, height adjustments, harness systems are designed to operate smoothly under the pressure of active therapy sessions.</p>
            </div>

            <div className="floating-card">
              <div className="card-icon-wrapper">2</div>
              <h4>From Assisted Standing to Full Gait Rehabilitation</h4>
              <p>Prime Rehab's product range covers the full spectrum of mobility rehabilitation. Patients who cannot yet bear their own weight are supported through the High Low Tilting Table and Fixed Height Tilting Table. As they progress, the Unweighing System takes them through supported standing and active gait training.</p>
            </div>

            <div className="floating-card">
              <div className="card-icon-wrapper">3</div>
              <h4>Clinical-Grade Engineering Across Every Component</h4>
              <p>Strong metal frames, precision-welded joints, motorized mechanisms rated for continuous clinical loads, and rexine upholstery selected for hygiene and long term durability these are not afterthoughts. Equipment that runs through a clinic six to eight hours a day has to be built to a standard that generic suppliers rarely match.</p>
            </div>

            <div className="floating-card">
              <div className="card-icon-wrapper">4</div>
              <h4>A Single Supplier for Your Entire Rehabilitation Setup</h4>
              <p>One of the practical advantages of working with Prime Rehab Industries is that you don't need to source from multiple vendors. Tilting tables, traction tables, Bobath tables, unweighing systems, chiropractic tables all manufactured by the same company, to the same quality standard, with consistent lead times.</p>
            </div>

            <div className="floating-card full-width">
              <div className="card-icon-wrapper">5</div>
              <h4>Custom Sizing for Patient Specific and Clinic Specific Needs</h4>
              <p>Mobility rehabilitation is not one size fits all. Neither is the equipment. Prime Rehab Industries offers custom sizing across its range adjusting table lengths, heights, and configurations to suit specific patient populations or clinic space requirements. If standard dimensions don't fit your setup, the team will manufacture to your specification.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Soft Quote Block */}
      <section className="soft-quote-section">
        <div className="soft-container">
          <div className="soft-quote-box">
            <div className="quote-mark">"</div>
            <blockquote>
              The tilting table from Prime Rehab has been a game changer for our mobility rehabilitation program. The motorized tilt is smooth and the harness system gives patients real confidence during standing therapy.
            </blockquote>
            <cite>— Dr. Anand Krishnamurthy, Physiotherapy Specialist, Tamil Nadu</cite>
          </div>
        </div>
      </section>

      {/* Horizontal Staggered Equipment Showcase */}
      <section className="soft-equipment-showcase">
        <div className="soft-container">
          <div className="section-title-soft">
            <h2>Key Mobility Aids and Rehab Products</h2>
            <p>Built for progression.</p>
          </div>

          <div className="horizontal-equip-card">
            <div className="equip-info">
              <h3>1. Tilting Tables for Postural and Weight-Bearing Rehabilitation</h3>
              <p>The High Low Tilting Table is one of the most clinically important products in Prime Rehab's range. It combines motorized hi-low height adjustment with a motorized tilt mechanism, harness clips for patient safety, and a foot leg adjustment board that moves from +20° to -120°.</p>
              <p>The Fixed Height Tilting Table offers the same motorized tilt capability at a fixed 75 cm height, with remote control operation and a non-slip foot step.</p>
            </div>
          </div>

          <div className="horizontal-equip-card right-align">
            <div className="equip-info">
              <h3>2. Unweighing and Gait Training Systems</h3>
              <p>The Unweighing System is purpose-built for patients who need to begin walking rehabilitation before they can bear their full body weight. The motorized DC lifting mechanism provides smooth, controlled unweighing. A digital hanging scale displays the exact load the system is supporting.</p>
              <p>Safety harness support and SS pipe walking rails give patients the stability to focus on movement rather than fear of falling.</p>
            </div>
          </div>

          <div className="horizontal-equip-card">
            <div className="equip-info">
              <h3>3. Height-Adjustable Treatment Tables for Active Mobility Work</h3>
              <p>The High Low Traction Table, High Low Two Fold Table, and High Low 3-Fold Table all feature electric height adjustment allowing therapists to position patients precisely for active mobility exercises, manual therapy, and progressive movement work.</p>
              <p>The multi section fold configurations support a wide range of treatment positions.</p>
            </div>
          </div>

          <div className="horizontal-equip-card right-align">
            <div className="equip-info">
              <h3>4. Spinal and Neurological Rehabilitation Equipment</h3>
              <p>Mobility challenges are frequently rooted in spinal or neurological conditions. The SPINETHERA DTS Table addresses spinal decompression needs with a precision traction lock system.</p>
              <p>The High Low Bobath Table provides a dedicated surface for Bobath neuro therapy — widely used for patients recovering from stroke and other neurological conditions that affect movement and mobility.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Second Soft Quote Block */}
      <section className="soft-quote-section alt">
        <div className="soft-container">
          <div className="soft-quote-box alt-color">
            <div className="quote-mark">"</div>
            <blockquote>
              We sourced our mobility rehabilitation equipment entirely from Prime Rehab. The quality across every product is consistent and the team was very professional throughout. Excellent company to work with.
            </blockquote>
            <cite>— Dr. Suganya Vijay, Rehabilitation Department Head, Chennai</cite>
          </div>
        </div>
      </section>

      {/* FAQs Soft Style */}
      <section className="soft-faq-section">
        <div className="soft-container">
          <h2 className="soft-gradient-text text-center">Frequently Asked Questions</h2>
          <div className="soft-faq-grid">
            <div className="soft-faq-item">
              <h5>What mobility aids and rehab products does Prime Rehab Industries supply in Tamil Nadu?</h5>
              <p>Prime Rehab Industries supplies a comprehensive range of mobility aids and rehab products in Tamil Nadu including high low tilting tables, unweighing systems for gait training, traction tables, Bobath neuro therapy tables, chiropractic tables, and multi-section treatment tables.</p>
            </div>
            <div className="soft-faq-item">
              <h5>Are Prime Rehab Industries products suitable for post-surgery mobility rehabilitation?</h5>
              <p>Yes. Prime Rehab Industries manufactures products specifically suited for post-surgery mobility rehabilitation, including the High Low Tilting Table for progressive weight-bearing, the Unweighing System for supported gait training, and height-adjustable treatment tables for active mobility exercises.</p>
            </div>
            <div className="soft-faq-item">
              <h5>Can Prime Rehab Industries supply both mobility aids and full rehabilitation equipment setups?</h5>
              <p>Yes. Prime Rehab Industries offers over 100 rehabilitation equipment models, allowing clinics and hospitals to source their full equipment setup from a single manufacturer. From individual mobility aids to complete physiotherapy department configurations, the company supplies everything needed.</p>
            </div>
            <div className="soft-faq-item">
              <h5>How does Prime Rehab Industries ensure the quality of its mobility and rehab products?</h5>
              <p>Prime Rehab Industries manufactures all its mobility and rehab products in-house, maintaining direct control over frame quality, mechanism engineering, and upholstery selection. With 12+ years of manufacturing experience and 1,000+ successful installations.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Footer Block */}
      <section className="soft-cta">
        <div className="soft-container">
          <div className="cta-glass-box">
            <h2>Find the Right Mobility Aids and Rehab Products for Your Clinic</h2>
            <p>From tilting tables and unweighing systems to complete rehabilitation department setups, Prime Rehab Industries is Tamil Nadu's trusted source for mobility aids and rehab products. Contact the team for a personalised product recommendation based on your clinic's specific needs.</p>
            <div className="cta-soft-buttons">
              <a href="tel:+919994351947" className="soft-btn-primary">Call +91 99943 51947</a>
              <a href="https://maps.app.goo.gl/placeholder" target="_blank" rel="noopener noreferrer" className="soft-btn-white">Visit on Google Maps</a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BestMobilityAids;
